import {
  Component,
  OnInit,
  AfterViewInit,
  OnChanges,
  Input,
  SimpleChanges,
  OnDestroy
} from "@angular/core";
import { TransportationWarehosueUtlizationService } from "./service/widget-transportation-warehouse-utilization.service";
import * as Highcharts from "highcharts";
import addMore from "highcharts/highcharts-more";
import { TranslateService } from "@ngx-translate/core";
import { query } from "@angular/animations";
import * as HSET from "./settings";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
addMore(Highcharts);

@Component({
  selector: "app-widget-transportation-warehouse-utilization",
  templateUrl: "./widget-transportation-warehouse-utilization.component.html",
  styleUrls: ["./widget-transportation-warehouse-utilization.component.scss"],
  providers: [TransportationWarehosueUtlizationService]
})
export class WidgetTransportationWarehouseUtilizationComponent
  implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  private unsubscribe: Subject<void> = new Subject();
  @Input() FILTERS;
  @Input() OPTIONS;
  @Input() TITLE;
  highcharts: typeof Highcharts = Highcharts;
  chartOptions = null;
  errorMessage = "";
  mockChart = null;

  constructor(
    private translateService: TranslateService,
    private dataService: TransportationWarehosueUtlizationService
  ) { }

  ngAfterViewInit() {
    this.getTransferEndToEndSlaTrendData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      JSON.stringify(changes.FILTERS.currentValue) !==
      JSON.stringify(changes.FILTERS.previousValue) &&
      !changes.FILTERS.firstChange
    ) {
      this.getTransferEndToEndSlaTrendData();
    }
  }

  ngOnInit() {
    this.translateService.get("HEADING_TEXT.TAT_BREAKUP")
      .pipe(takeUntil(this.unsubscribe)).subscribe(text => {
        this.OPTIONS.title = this.OPTIONS.title || text;
      });
  }

  getTransferEndToEndSlaTrendData() {
    this.chartOptions = null;
    this.errorMessage = "";
    this.mockChart = null;
    const options = {
      url: this.OPTIONS.api,
      params: this.FILTERS,
      query: ""
    };

    this.dataService.getData(options)
      .pipe(takeUntil(this.unsubscribe)).subscribe(
        chartData => {
          if (chartData.greaterThan3.length > 1) {
            this.chartOptions = this.dataService.createChart(
              chartData,
              this.OPTIONS
            );
          } else {
            this.errorMessage = "ERROR_MSG.NO_DATA";
            this.mockChart = HSET.chartData;
          }
        },
        error => {
          this.errorMessage = "ERROR_MSG.SYSTEM_ERROR";
          this.mockChart = HSET.chartData;
        }
      );
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
